function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

// Generate fur lines along a contour (head or body)
export function generateFurLines(contour, density = 0.3) {
  let furLines = [];

  // Sample points along the contour
  let sampleRate = Math.max(1, Math.floor(contour.length * (1 - density)));

  for (let i = 0; i < contour.length; i += sampleRate) {
    if (Math.random() > 0.5) continue; // Random skip for natural look

    let point = contour[i];

    // Calculate normal direction (perpendicular to contour)
    let prevPoint = contour[i > 0 ? i - 1 : contour.length - 1];
    let nextPoint = contour[i < contour.length - 1 ? i + 1 : 0];

    // Tangent vector
    let dx = nextPoint[0] - prevPoint[0];
    let dy = nextPoint[1] - prevPoint[1];
    let len = Math.sqrt(dx * dx + dy * dy);

    if (len === 0) continue;

    // Normal vector (perpendicular, pointing outward)
    let nx = -dy / len;
    let ny = dx / len;

    // Fur line length and slight randomness
    let furLength = randomFromInterval(3, 12);
    let angleVariation = randomFromInterval(-0.3, 0.3);

    // Apply angle variation
    let cos = Math.cos(angleVariation);
    let sin = Math.sin(angleVariation);
    let nnx = nx * cos - ny * sin;
    let nny = nx * sin + ny * cos;

    // End point of fur line
    let endX = point[0] + nnx * furLength;
    let endY = point[1] + nny * furLength;

    furLines.push({
      start: [point[0], point[1]],
      end: [endX, endY]
    });
  }

  return furLines;
}

// Generate fluffy fur texture on body (random short lines within body area)
export function generateBodyFurTexture(bodyBounds, count = 20) {
  let textures = [];

  // bodyBounds should have minX, maxX, minY, maxY
  let { minX, maxX, minY, maxY } = bodyBounds;

  for (let i = 0; i < count; i++) {
    let x = randomFromInterval(minX, maxX);
    let y = randomFromInterval(minY, maxY);

    // Random angle and length for texture line
    let angle = randomFromInterval(0, Math.PI * 2);
    let length = randomFromInterval(5, 15);

    let endX = x + Math.cos(angle) * length;
    let endY = y + Math.sin(angle) * length;

    textures.push({
      start: [x, y],
      end: [endX, endY]
    });
  }

  return textures;
}

// Generate chest/neck fur (longer fur in specific areas)
export function generateChestFur(centerX, centerY, count = 8) {
  let chestFur = [];

  for (let i = 0; i < count; i++) {
    // Random position around chest area
    let offsetX = randomFromInterval(-15, 15);
    let offsetY = randomFromInterval(-10, 20);

    let startX = centerX + offsetX;
    let startY = centerY + offsetY;

    // Fur hanging downward with variation
    let furLength = randomFromInterval(10, 25);
    let angleOffset = randomFromInterval(-0.4, 0.4);
    let angle = Math.PI / 2 + angleOffset; // Mostly downward

    let endX = startX + Math.cos(angle) * furLength;
    let endY = startY + Math.sin(angle) * furLength;

    chestFur.push({
      start: [startX, startY],
      end: [endX, endY]
    });
  }

  return chestFur;
}

// Generate tail fur (wispy lines at tail tip)
export function generateTailFur(tailTip, tailDirection, count = 5) {
  let tailFur = [];

  if (!tailTip || tailTip.length < 2) return tailFur;

  let tipX = tailTip[0];
  let tipY = tailTip[1];

  // Base angle from tail direction
  let baseAngle = Math.atan2(tailDirection[1], tailDirection[0]);

  for (let i = 0; i < count; i++) {
    let angleVariation = randomFromInterval(-0.6, 0.6);
    let angle = baseAngle + angleVariation;
    let length = randomFromInterval(8, 20);

    let startX = tipX + randomFromInterval(-3, 3);
    let startY = tipY + randomFromInterval(-3, 3);

    let endX = startX + Math.cos(angle) * length;
    let endY = startY + Math.sin(angle) * length;

    tailFur.push({
      start: [startX, startY],
      end: [endX, endY]
    });
  }

  return tailFur;
}
